module.exports = __webpack_public_path__ + "static/media/shop-512.7332bc26.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop-512.png
// module id = 784
// module chunks = 0